/* Keep the shopper's language on every link to this shop.
 *
 * Anna, 2026-09-28: "I choose a language on the home page, click any element, and the
 * site is English again." Shopify keeps a language only in the URL prefix (/de/, /fr/ …).
 * Our own widgets (reviews carousel, customer ideas, wishlist) and some hard-coded theme
 * links point at https://artapli.shop/products/… with no prefix, so one click dropped the
 * shopper back to English. This adds the current prefix to same-shop links, form actions
 * and data-url targets, including ones widgets insert later. On the English site it does
 * nothing. */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (!/^\/[a-z]{2}(-[a-z]{2,4})?\/$/i.test(root)) return;
  var prefix = root.slice(0, -1);
  var hosts = [location.host, 'artapli.shop', 'www.artapli.shop'];
  var localized = /^\/[a-z]{2}(-[a-z]{2,4})?(\/|$)/i;
  var shopPath = /^\/(collections|products|pages|blogs|search|cart|account)(\/|$|\?)|^\/$/;

  // Studio (Library, Mockup, Editor) reads its language only from ?lang= on the page it opens,
  // so a Studio link carries the shop's language inside return_path (Anna, 2026-09-29: "clicked
  // Library in the Italian shop and it opened in English").
  var studioLang = ((window.Shopify && window.Shopify.locale) || prefix.slice(1)).slice(0, 2).toLowerCase();
  function studio(url, relative) {
    if (url.pathname !== '/apps/artapli-studio/studio-entry') return null;
    if (['de', 'fr', 'it', 'es'].indexOf(studioLang) === -1) return null;
    var back = url.searchParams.get('return_path') || '/library/';
    if (/[?&]lang=/.test(back)) return null;
    url.searchParams.set('return_path', back + (back.indexOf('?') === -1 ? '?' : '&') + 'lang=' + studioLang);
    return relative ? url.pathname + url.search + url.hash : url.href;
  }

  function fix(value) {
    if (!value || value.charAt(0) === '#' || /^(mailto:|tel:|javascript:)/i.test(value)) return null;
    var url;
    try { url = new URL(value, location.href); } catch (e) { return null; }
    if (hosts.indexOf(url.host) === -1) return null;
    if (url.pathname === '/apps/artapli-studio/studio-entry') return studio(url, !/^[a-z]+:\/\//i.test(value));
    if (localized.test(url.pathname) || !shopPath.test(url.pathname)) return null;
    var relative = !/^[a-z]+:\/\//i.test(value) && value.charAt(0) === '/';
    var path = prefix + (url.pathname === '/' ? '' : url.pathname) + url.search + url.hash;
    return relative ? path : location.origin + path;
  }

  function fixNode(node) {
    if (node.nodeType !== 1) return;
    var targets = node.matches && node.matches('a[href],form[action],[data-url]') ? [node] : [];
    if (node.querySelectorAll) targets = targets.concat(Array.prototype.slice.call(node.querySelectorAll('a[href],form[action],[data-url]')));
    targets.forEach(function (el) {
      [['A', 'href'], ['FORM', 'action'], [null, 'data-url']].forEach(function (pair) {
        if (pair[0] && el.tagName !== pair[0]) return;
        if (!el.hasAttribute(pair[1])) return;
        var next = fix(el.getAttribute(pair[1]));
        if (next && next !== el.getAttribute(pair[1])) el.setAttribute(pair[1], next);
      });
    });
  }

  function start() {
    fixNode(document.body);
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        if (record.type === 'attributes') fixNode(record.target);
        else record.addedNodes.forEach(fixNode);
      });
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href', 'action', 'data-url'] });
    // Last line of defence: a link rewritten by some script right before the click.
    // Qikify's mega menu renders its links inside a shadow root. The document observer
    // cannot enter that root and event.target is retargeted to the custom element, but
    // the composed event path still contains the real anchor. Fix that anchor before
    // Shopify follows it, so Apps opened from /it, /de, /fr or /es keep the locale.
    document.addEventListener('click', function (event) {
      var link = null;
      var path = typeof event.composedPath === 'function' ? event.composedPath() : [];
      for (var i = 0; i < path.length; i += 1) {
        if (path[i] && path[i].matches && path[i].matches('a[href]')) {
          link = path[i];
          break;
        }
      }
      if (!link && event.target.closest) link = event.target.closest('a[href]');
      if (link) fixNode(link);
    }, true);
  }

  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();
